/*
  钉钉调用API封装
*/
import * as dd from 'dingtalk-jsapi'
import { timeFormat, getTitle } from '@/utils/comUtils'
export function dingJsAuthConfig(config) {
  return new Promise((resolve, reject) => {
    // 配置jsapi
    dd.config({
      agentId: config.agentId,
      corpId: config.corpId,
      timeStamp: config.timeStamp,
      nonceStr: config.nonceStr,
      signature: config.signature,
      jsApiList: [
        'runtime.permission.requestAuthCode', // 获取微应用免登授权码
        'device.connection.getNetworkType', // 获取当前网络类型
        'device.notification.showPreloader', // 显示加载中
        'device.notification.hidePreloader', // 隐藏加载中
        'device.notification.alert', // alert弹窗
        'device.notification.confirm', // 确认窗口
        'device.notification.prompt', // 输入窗口
        'device.notification.toast', // 黑色提示窗
        'device.notification.actionSheet', // 底部单选列表,
        'device.geolocation.get', // 地图定位
        'device.audio.startRecord', // 开始录音
        'device.audio.stopRecord', // 停止录音
        'device.audio.onRecordEnd', // 监听录音自动停止
        'device.audio.download', // 下载音频
        'device.audio.play', // 播放语音
        'device.audio.pause', // 暂停播放语音
        'device.audio.resume', // 恢复暂停播放的语音
        'device.audio.stop', // 停止播放音频
        'device.audio.onPlayEnd', // 监听播放自动停止
        'device.audio.translateVoice', // 语音转文字
        'biz.map.locate', // 地图定位
        'biz.map.search', // 地图搜索
        'biz.util.scan', // 扫描二维码
        'biz.util.open', // 打开应用内页面
        'biz.util.openLink', // 在新窗口上打开链接
        'biz.util.datepicker', // 日期选择器
        'biz.util.timepicker', // 时间选择
        'biz.util.datetimepicker', // 日期+时间
        'biz.util.chosen', // 下拉控件
        'biz.util.pay', // 支付
        'biz.calendar.chooseInterval', // 日历组件，选择日期区间
        'biz.contact.complexPicker', // 选人选部门支持选择部门后，把所选部门转换成对应部门下的人，permissionType可以添加权限校验
        'biz.contact.externalComplexPicker', // 选择外部联系人
        'biz.contact.externalEditForm', // 编辑外部联系人
        'biz.contact.chooseMobileContacts', // 手机通讯录
        'biz.customContact.choose', // 单选自定义联系人
        'biz.customContact.multipleChoose', // 多选自定义联系人
        'biz.ding.create', // 发钉消息
        'biz.navigation.setTitle', // 设置导航栏标题  iOS：根据iOS的设计规范，iOS的标题在导航栏正中央
        'biz.navigation.setLeft', // 设置左侧导航按钮 因为Android导航栏左侧显示的是标题（设置导航栏标题），所以此jsapi只支持iOS。
        'biz.navigation.setRight', // 设置导航栏右侧单个按钮 设置导航栏最右侧按钮的文字，并且接收点击事件
        'biz.navigation.setMenu', // 设置导航栏右侧多个按钮 点击任一一个按钮将会回调onSuccess，并返回被点击item的id
        'biz.navigation.close', // 触发关闭 关闭当前浏览器窗口
        'biz.navigation.goBack', // 触发关闭 关闭当前浏览器窗口
        'biz.util.previewImage', // 图片预览
        'biz.contact.departmentsPicker', // 部门选择
        'biz.telephone.showCallMenu', // 电话
        'biz.chat.pickConversation', // 获取会话信息
        'biz.chat.chooseConversationByCorpId', // 根据corpid选择会话
        'biz.chat.openSingleChat', // 打开与某个用户的单聊会话
        'biz.chat.toConversation', // 根据chatid跳转到对应会话
        'biz.auth.requestAuthInfo', // 审批授权
        'biz.util.share', // 分享
        'biz.cspace.preview', // 钉盘图片预览
        'previewFileInDingTalk'
      ]
    })
    // eslint-disable-next-line space-before-function-paren
    dd.ready(function () {
      // 获取免登Code
      // dingRequestAuthCode(config.corpId)
      // cubeRequestAuthCode(config.corpId)
      dd.runtime.permission.requestAuthCode({
        corpId: config.corpId,
        onSuccess(code) {
          resolve(code)
        },
        onFail(e) {
          console.log('dd fail: ' + window.JSON.stringify(e))
          reject(new Error(window.JSON.stringify(e) + '获取免登标识失败'))
        }
      })
    })
    // eslint-disable-next-line space-before-function-paren
    dd.error(function (e) {
      console.log('dd error: ' + window.JSON.stringify(e))
      reject(new Error(window.JSON.stringify(e) + '授权开放接口失败'))
    })
  })
}

export function dingRequestAuthCode(corpId) {
  return new Promise((resolve, reject) => {
    dd.runtime.permission.requestAuthCode({
      corpId: corpId,
      onSuccess(result) {
        resolve((result || {}).code || '')
      },
      onFail(e) {
        console.log('dd error: ' + window.JSON.stringify(e))
        reject(new Error(window.JSON.stringify(e) + '获取免登标识失败'))
      }
    })
  })
}

export function dingOpenPage({ name, params }) {
  return new Promise((resolve, reject) => {
    dd.biz.util.open({
      name: name, // 页面名称
      params: params, // 传参
      onSuccess() {
        resolve()
      },
      onFail(e) {
        reject(e)
      }
    })
  })
}

export function dingOpenLink({ url }) {
  return new Promise((resolve, reject) => {
    dd.biz.util.openLink({
      url: url,
      onSuccess() {
        resolve()
      },
      onFail(e) {
        reject(e)
      }
    })
  })
}
export function dingNavigateToPage({ url }) {
  return new Promise((resolve, reject) => {
    dd.navigateToPage({
      url,
      success: () => {},
      fail: () => {},
      complete: () => {}
    })
  })
}

export function dingTimePicker({ time }) {
  return new Promise((resolve, reject) => {
    dd.biz.util.timepicker({
      format: 'HH:mm',
      value: time, // 默认显示时间  0.0.3
      onSuccess(res) {
        resolve(res.value)
      },
      onFail(e) {
        reject(e)
      }
    })
  })
}

export function dingDatePicker({ date, format = 'yyyy-MM-dd' }) {
  return new Promise((resolve, reject) => {
    dd.biz.util.datepicker({
      format: format,
      value: date, // 默认显示时间  0.0.3
      onSuccess(res) {
        resolve(res.value)
      },
      onFail(e) {
        reject(e)
      }
    })
  })
}

export function dingDateTimePicker(datetime, format = 'yyyy-MM-dd HH:mm') {
  return new Promise((resolve, reject) => {
    dd.biz.util.datetimepicker({
      format: format,
      value: datetime, // 默认显示 2015-04-17 08:00
      // eslint-disable-next-line space-before-function-paren
      onSuccess: function (res) {
        resolve(res.value)
      },
      onFail(e) {
        reject(e)
      }
    })
  })
}

export function dingChooseOneDay(date) {
  return new Promise((resolve, reject) => {
    dd.biz.util.chooseOneDay({
      default: date, // 默认显示 2015-04-17 08:00
      // eslint-disable-next-line space-before-function-paren
      onSuccess: function (res) {
        resolve(res.chosen)
      },
      onFail(e) {
        reject(e)
      }
    })
  })
}

export function dingModal({
  image = '',
  buttonName = ['取消', '确认'],
  title = '',
  content = '',
  banner = []
} = {}) {
  return new Promise((resolve, reject) => {
    dd.device.notification.modal({
      image: image,
      banner: banner,
      title: title,
      content: content,
      buttonLabels: buttonName,
      onSuccess(result) {
        resolve(result)
      },
      onFail(e) {
        reject(e)
      }
    })
  })
}

export function dingSetTitle(title = getTitle()) {
  return new Promise((resolve, reject) => {
    dd.biz.navigation.setTitle({
      title: title,
      // eslint-disable-next-line space-before-function-paren
      onSuccess: function () {
        resolve()
      },
      onFail(e) {
        reject(e)
      }
    })
    resolve()
  })
}
export function downloadFile({
  corpId,
  spaceId,
  fileId,
  fileName,
  fileType,
  fileSize
}) {
  return new Promise((resolve, reject) => {
    dd.biz.cspace.preview({
      corpId,
      spaceId,
      fileId,
      fileName,
      fileSize: fileSize,
      fileType: 'mp4',

      // spaceId: '24278449666',
      // fileId: '140989313187',
      // fileName: '1799917113494732800_1716535343313.mp4',
      // fileSize: 10016240,
      // fileType: 'mp4',

      onSuccess: function (res) {
        resolve(res)
      },
      onFail: function (err) {
        reject(err)
      }
    })
  })
}
export function dingSetLeft({
  show = true,
  control = false,
  text = '返回',
  showIcon = true
} = {}) {
  return new Promise((resolve, reject) => {
    dd.biz.navigation.setLeft({
      show: show, // 控制按钮显示， true 显示， false 隐藏， 默认true
      control: control, // 是否控制点击事件，true 控制，false 不控制， 默认false
      showIcon: showIcon, // 是否显示icon，true 显示， false 不显示，默认true； 注：具体UI以客户端为准
      text: text, // 控制显示文本，空字符串表示显示默认文本
      onSuccess() {
        resolve()
      },
      onFail(e) {
        reject(e)
      }
    })
  })
}

export function dingSetRight({
  show = true,
  control = false,
  text = '',
  handle = () => {}
} = {}) {
  return new Promise((resolve, reject) => {
    dd.biz.navigation.setRight({
      show: show, // 控制按钮显示， true 显示， false 隐藏， 默认true
      control: control, // 是否控制点击事件，true 控制，false 不控制， 默认false
      text: text, // 控制显示文本，空字符串表示显示默认文本
      onSuccess() {
        handle()
        resolve()
      },
      onFail(e) {
        reject(e)
      }
    })
  })
}

export function dingSetMenu({ backgroundColor = '#FFFFFF', items = [] } = {}) {
  // items : [{
  //     id: 1,
  //     iconId: '',
  //     text: '帮助',
  //     url: 'http://img.alicdn.com/tps/TB1XLjqNVXXXXc4XVXXXXXXXXXX-170-64.png'
  // }],
  return new Promise((resolve, reject) => {
    dd.biz.navigation.setMenu({
      backgroundColor: backgroundColor,
      items: items,
      onSuccess(res) {
        resolve(res)
      },
      onFail(e) {
        reject(e)
      }
    })
  })
}

export function dingClosePage() {
  return new Promise((resolve, reject) => {
    dd.biz.navigation.close({
      onSuccess() {
        resolve()
      },
      onFail(e) {
        reject(e)
      }
    })
  })
}

export function dingGoBack() {
  return new Promise((resolve, reject) => {
    dd.biz.navigation.goBack({
      onSuccess() {
        resolve()
      },
      onFail(e) {
        reject(e)
      }
    })
  })
}
export function dingShowPreloader(text) {
  return new Promise((resolve, reject) => {
    dd.device.notification.showPreloader({
      text: text || '', // loading显示的字符，空表示不显示文字
      showIcon: true, // 是否显示icon，默认true
      onSuccess() {
        resolve()
      },
      onFail(e) {
        reject(e)
      }
    })
  })
}

export function dingHidePreloader(text) {
  return new Promise((resolve, reject) => {
    dd.device.notification.hidePreloader({
      onSuccess() {
        resolve()
      },
      onFail(e) {
        reject(e)
      }
    })
  })
}

export function dingToast({ msg, duration, delay = 0, icon = '' } = {}) {
  return new Promise((resolve, reject) => {
    dd.device.notification.toast({
      icon: icon, // icon样式，有success和error，默认为空 0.0.2
      text: msg, // 提示信息
      duration: duration || 2, // 显示持续时间，单位秒，默认按系统规范[android只有两种(<=2s >2s)]
      delay: delay, // 延迟显示，单位秒，默认0
      onSuccess() {
        resolve()
      },
      onFail(e) {
        reject(e)
      }
    })
  })
}

export function dingAlert({ msg, buttonName = '知道了', title = '' } = {}) {
  return new Promise((resolve, reject) => {
    dd.device.notification.alert({
      message: msg,
      title,
      buttonName: buttonName,
      onSuccess() {
        resolve()
      },
      onFail(e) {
        reject(e)
      }
    })
  })
}

export function dingConfirm({
  msg = '',
  buttonName = ['取消', '确认'],
  title = ''
} = {}) {
  return new Promise((resolve, reject) => {
    dd.device.notification.confirm({
      message: msg,
      title: title,
      buttonLabels: buttonName,
      onSuccess(result) {
        resolve(+result.buttonIndex)
      },
      onFail(e) {
        reject(e)
      }
    })
  })
}

export function dingTelephone({
  phoneNumber = '',
  code = '+86',
  showDingCall = false
} = {}) {
  return new Promise((resolve, reject) => {
    dd.biz.telephone.showCallMenu({
      phoneNumber: phoneNumber, // 期望拨打的电话号码
      code: code, // 国家代号，中国是+86
      showDingCall: showDingCall, // 是否显示钉钉电话
      onSuccess(result) {
        resolve(result)
      },
      // eslint-disable-next-line space-before-function-paren
      onFail: function (e) {
        reject(e)
      }
    })
  })
}

export function dingPrompt({
  msg = '',
  buttonName = ['取消', '确认'],
  title = ''
} = {}) {
  return new Promise((resolve, reject) => {
    dd.device.notification.prompt({
      message: msg,
      title: title,
      buttonLabels: buttonName,
      onSuccess(result) {
        resolve(result)
      },
      onFail(e) {
        reject(e)
      }
    })
  })
}

export function dingDropDown({
  list = [{ key: '请选择', value: '请选择' }],
  defaultKey = '请选择'
} = {}) {
  return new Promise((resolve, reject) => {
    dd.biz.util.chosen({
      source: list,
      selectedKey: defaultKey, // 默认选中的key
      onSuccess(result) {
        resolve(result)
      },
      onFail(e) {
        reject(e)
      }
    })
  })
}

export const dingActionSheet = ({
  title = '',
  cancelButton = '取消',
  buttonName = []
}) => {
  return new Promise((resolve, reject) => {
    dd.device.notification.actionSheet({
      title: title,
      cancelButton: cancelButton, // 取消按钮的文本
      otherButtons: buttonName,
      onSuccess(result) {
        resolve(result)
      },
      onFail(e) {
        reject(e)
      }
    })
  })
}

export function dingScan({ type = 'qrCode' }) {
  return new Promise((resolve, reject) => {
    dd.biz.util.scan({
      type: type, // type为qrCode或者barCode
      onSuccess(data) {
        resolve(data.text || '')
      },
      onFail(e) {
        reject(e)
      }
    })
  })
}

// 启用下拉刷新
export function dingEnablePullRefresh() {
  return new Promise((resolve, reject) => {
    dd.ui.pullToRefresh.enable({
      onSuccess() {
        resolve()
      },
      onFail(e) {
        reject(e)
      }
    })
  })
}

// 关闭下拉刷新
export function dingStopPullRefresh() {
  return new Promise((resolve, reject) => {
    dd.ui.pullToRefresh.stop({
      onSuccess() {
        resolve()
      },
      onFail(e) {
        reject(e)
      }
    })
  })
}

// 禁用下拉刷新
export function dingDisablePullRefresh() {
  return new Promise((resolve, reject) => {
    dd.ui.pullToRefresh.disable()
    resolve()
  })
}

// 禁用iOS webview弹性效果
export function dingDisableWebViewBounce() {
  return new Promise((resolve, reject) => {
    dd.ui.webViewBounce.disable()
    resolve()
  })
}

// export function dingChoosePerson ({start = 0, multiple = false, defaultUserid = [], disableUserid = [], max = 100, title = '请选择人员', corpId} = {}) {
//   return new Promise((resolve, reject) => {
//     dd.biz.contact.choose({
//       startWithDepartmentId: start, // -1表示打开的通讯录从自己所在部门开始展示, 0表示从企业最上层开始，(其他数字表示从该部门开始:暂时不支持)
//       multiple: multiple, // 是否多选： true多选 false单选； 默认true
//       users: defaultUserid, // 默认选中的用户列表，userid；成功回调中应包含该信息
//       disabledUsers: disableUserid, // 不能选中的用户列表，员工userid
//       corpId: corpId, // 企业id
//       max: max, // 人数限制，当multiple为true才生效，可选范围1-1500
//       limitTips: '最多可选择' + max + '人', // 超过人数限制的提示语可以用这个字段自定义
//       isNeedSearch: true, // 是否需要搜索功能
//       title: title, // 如果你需要修改选人页面的title，可以在这里赋值
//       local: false, // 是否显示本地联系人，默认false
//       onSuccess (data) {
//         resolve(data)
//       },
//       onFail (e) {
//         reject(e)
//       }
//     })
//   })
// }

// 选择人和部门
export function dingComplexPicker({
  title = '请选择人员',
  corpId,
  multiple = false,
  maxUsers = 1500,
  pickedUsers = [],
  pickedDepartments = [],
  disabledUsers = [],
  disabledDepartments = [],
  requiredUsers = [],
  requiredDepartments = [],
  appId = '',
  responseUserOnly = true
} = {}) {
  return new Promise((resolve, reject) => {
    dd.biz.contact.complexPicker({
      title: title, // 如果你需要修改选人页面的title，可以在这里赋值
      corpId: corpId, // 企业id
      multiple: multiple, // 是否多选： true多选 false单选； 默认true
      limitTips: '最多可选择' + maxUsers + '人', // 超过人数限制的提示语可以用这个字段自定义
      maxUsers: maxUsers, // 人数限制，当multiple为true才生效，可选范围1-1500
      pickedUsers: pickedUsers, // 已选用户
      pickedDepartments: pickedDepartments, // 已选部门
      disabledUsers: disabledUsers, // 不可选用户
      disabledDepartments: disabledDepartments, // 不可选部门
      requiredUsers: requiredUsers, // 必选用户（不可取消选中状态）
      requiredDepartments: requiredDepartments, // 必选部门（不可取消选中状态）
      appId: appId, // 微应用的Id
      permissionType: 'GLOBAL', // 选人权限，目前只有GLOBAL这个参数
      responseUserOnly: responseUserOnly, // 返回人，或者返回人和部门
      onSuccess(data) {
        resolve(data)
      },
      onFail(e) {
        reject(e)
      }
    })
  })
}

export function dingChooseExtraPerson({
  multiple = false,
  pickedUsers = [],
  disabledUsers = [],
  requiredUsers = [],
  max = 5,
  title = '选择外部联系人',
  corpId
} = {}) {
  return new Promise((resolve, reject) => {
    dd.biz.contact.externalComplexPicker({
      title: title,
      corpId: corpId,
      multiple: multiple, // 是否多选  true多选，false单选，默认是单选
      limitTips: '最多可选择' + max + '人',
      maxUsers: max, // 默认不限制
      pickedUsers: pickedUsers, // 已选，但可取消，只针对多选生效
      disabledUsers: disabledUsers, // 不可选，，只针对多选生效
      requiredUsers: requiredUsers, // 必选，只针对多选生效
      onSuccess(data) {
        resolve(data)
      },
      onFail(e) {
        reject(e)
      }
    })
  })
}

export function dingEditExternalForm({
  title = '编辑外部联系人',
  corpId,
  emplId,
  name,
  mobile,
  companyName,
  deptName,
  job,
  remark
} = {}) {
  return new Promise((resolve, reject) => {
    dd.biz.contact.externalEditForm({
      title: title,
      corpId: corpId,
      emplId: emplId, // 无emplId 就是添加 有就是编辑修改
      name: name,
      mobile: mobile,
      companyName: companyName,
      deptName: deptName,
      job: job,
      remark: remark,
      onSuccess(data) {
        resolve(data)
      },
      onFail(e) {
        reject(e)
      }
    })
  })
}

// 地图
export const dingGetLocation = ({
  targetAccuracy = 200,
  coordinate = 1,
  withReGeocode = false
} = {}) => {
  return new Promise((resolve, reject) => {
    dd.device.geolocation.get({
      targetAccuracy: targetAccuracy, // 期望定位精度半径（单位米）,推荐采用200m，可获得较好的精度和较短的响应时长
      coordinate: coordinate, // 1：获取高德坐标， 0：获取标准坐标
      withReGeocode: withReGeocode, // 是否需要带有逆地理编码信息；该功能需要网络请求，请更具自己的业务场景使用
      useCache: true, // 默认是true，如果需要频繁获取地理位置，请设置false
      onSuccess(res) {
        // longitude : Number,
        // latitude : Number,
        // accuracy : Number,
        // road : String,
        // netType : String,
        // operatorType : String,
        // errorMessage : String,
        resolve(res)
      },
      onFail(err) {
        reject(err)
      }
    })
  })
}

export const dingMapLocation = ({ latitude, longitude } = {}) => {
  return new Promise((resolve, reject) => {
    dd.biz.map.locate({
      latitude: latitude, // 纬度
      longitude: longitude, // 经度
      onSuccess(res) {
        // province: 'xxx', // POI所在省会
        // provinceCode: 'xxx', // POI所在省会编码
        // city: 'xxx', // POI所在城市
        // cityCode: 'xxx', // POI所在城市
        // adName: 'xxx', // POI所在区名称
        // adCode: 'xxx', // POI所在区编码
        // distance: 'xxx', // POI与设备位置的距离
        // postCode: 'xxx', // POI的邮编
        // snippet: 'xxx', // POI的街道地址
        // title: 'xxx', // POI的名称
        // latitude: 39.903578, // POI的纬度
        // longitude: 116.473565, // POI的经度
        resolve(res)
      },
      onFail(err) {
        reject(err)
      }
    })
  })
}

export const dingMapSearch = ({ latitude, longitude, scope = 500 } = {}) => {
  return new Promise((resolve, reject) => {
    dd.biz.map.search({
      latitude: latitude, // 纬度
      longitude: longitude, // 经度
      scope: scope, // 限制搜索POI的范围；设备位置为中心，scope为搜索半径
      onSuccess(res) {
        // province: 'xxx', // POI所在省会
        // provinceCode: 'xxx', // POI所在省会编码
        // city: 'xxx', // POI所在城市
        // cityCode: 'xxx', // POI所在城市
        // adName: 'xxx', // POI所在区名称
        // adCode: 'xxx', // POI所在区编码
        // distance: 'xxx', // POI与设备位置的距离
        // postCode: 'xxx', // POI的邮编
        // snippet: 'xxx', // POI的街道地址
        // title: 'xxx', // POI的名称
        // latitude: 39.903578, // POI的纬度
        // longitude: 116.473565, // POI的经度
        resolve(res)
      },
      onFail(err) {
        reject(err)
      }
    })
  })
}

export const dingChooseMobileContacts = ({
  multiple = false,
  maxUsers = 1,
  title = '从手机通讯录中选择'
} = {}) => {
  return new Promise((resolve, reject) => {
    dd.biz.contact.chooseMobileContacts({
      multiple: multiple, // 是否多选： true多选 false单选； 默认true
      maxUsers: maxUsers, // 人数限制，当multiple为true才生效，可选范围1-1500
      limitTips: `最多可选择${maxUsers}人`, // 超过人数限制的提示语可以用这个字段自定义
      title: title, // 如果你需要修改选人页面的title，可以在这里赋值
      onSuccess(res) {
        resolve(res)
      },
      onFail(err) {
        reject(err)
      }
    })
  })
}

export const dingChooseInterval = ({
  defaultStart = new Date().getTime(),
  defaultEnd = new Date().getTime(),
  format = 'YYYY-MM-DD hh:mm:ss'
} = {}) => {
  return new Promise((resolve, reject) => {
    dd.biz.calendar.chooseInterval({
      defaultStart: defaultStart,
      defaultEnd: defaultEnd,
      onSuccess(res) {
        let _date = {}
        _date.start = timeFormat(new Date(res.start), format)
        _date.end = timeFormat(new Date(res.end), format)
        resolve(_date)
      },
      onFail(err) {
        reject(err)
      }
    })
  })
}

export const dingChooseHalfDay = (defaultTime = new Date().getTime()) => {
  return new Promise((resolve, reject) => {
    dd.biz.calendar.chooseHalfDay({
      default: defaultTime,
      onSuccess(res) {
        resolve(res)
      },
      onFail(err) {
        reject(err)
      }
    })
  })
}

export const dingPreviewImage = ({ urls, current }) => {
  return new Promise((resolve, reject) => {
    dd.biz.util.previewImage({
      urls: urls,
      current: current,
      onSuccess(res) {
        resolve(res)
      },
      onFail(err) {
        reject(err)
      }
    })
  })
}

export const dingDpartmentsPicker = ({
  title = '部门选择',
  corpId,
  multiple = true,
  maxCount,
  pickedDepartments = [],
  disabledDepartments = [],
  requiredDepartments = [],
  appId
}) => {
  return new Promise((resolve, reject) => {
    dd.biz.contact.departmentsPicker({
      title: title, // 标题
      corpId: corpId || '', // 企业的corpId
      multiple: multiple, // 是否多选
      limitTips: `最多可选择${maxCount}个部门`, // 超过限定人数返回提示
      maxDepartments: maxCount, // 最大选择部门数量
      pickedDepartments: pickedDepartments, // 选部门
      disabledDepartments: disabledDepartments, // 不可选部门
      requiredDepartments: requiredDepartments, // 必选部门（不可取消选中状态）
      appId: appId, // 微应用的Id
      permissionType: 'GLOBAL', // 选人权限，目前只有GLOBAL这个参数
      onSuccess(res) {
        resolve(res)
      },
      onFail(err) {
        reject(err)
      }
    })
  })
}

/**
 * 发送钉消息
 * @param {Object} params 钉消息配置信息
 * 配置详情: https://open-doc.dingtalk.com/microapp/dev/lnq1g3#ding-20-%E5%8F%91%E9%92%89
 */
export const dingSendDing = params => {
  return new Promise((resolve, reject) => {
    let _params = {
      ...params
    }
    _params.type === undefined && (_params.type = 2) // 附件类型 1：image  2：link
    _params.alertType === undefined && (_params.alertType = 2) // 钉发送方式 0:电话, 1:短信, 2:应用内
    _params.bizType === undefined && (_params.bizType = 0) // 业务类型 0：通知DING；1：任务；2：会议

    dd.biz.ding.create({
      ..._params,
      onSuccess(res) {
        resolve(res)
      },
      onFail(err) {
        reject(err)
      }
    })
  })
}

// 开始录音
export function dingAudioStartRecord(maxDuration = 60) {
  return new Promise((resolve, reject) => {
    dd.device.audio.startRecord({
      maxDuration: maxDuration,
      onSuccess() {
        resolve()
      },
      onFail(e) {
        reject(e)
      }
    })
  })
}

// 停止录音
export function dingAudioStopRecord() {
  return new Promise((resolve, reject) => {
    dd.device.audio.stopRecord({
      onSuccess(res) {
        resolve(res)
      },
      onFail(e) {
        reject(e)
      }
    })
  })
}

// 监听录音自动停止
export function dingAudioEnd() {
  return new Promise((resolve, reject) => {
    dd.device.audio.onRecordEnd({
      onSuccess(res) {
        resolve(res)
      },
      onFail(e) {
        reject(e)
      }
    })
  })
}

// 下载音频
export function dingAudioDownload(mediaId) {
  return new Promise((resolve, reject) => {
    dd.device.audio.download({
      mediaId: mediaId,
      onSuccess(res) {
        resolve(res)
      },
      onFail(e) {
        reject(e)
      }
    })
  })
}

// 播放语音
export function dingAudioPlay(localAudioId) {
  return new Promise((resolve, reject) => {
    dd.device.audio.play({
      localAudioId: localAudioId,
      onSuccess() {
        resolve()
      },
      onFail(e) {
        reject(e)
      }
    })
  })
}

// 暂停播放语音
export function dingAudioPause(localAudioId) {
  return new Promise((resolve, reject) => {
    dd.device.audio.pause({
      localAudioId: localAudioId,
      onSuccess() {
        resolve()
      },
      onFail(e) {
        reject(e)
      }
    })
  })
}

// 恢复暂停播放的语音
export function dingAudioResume(localAudioId) {
  return new Promise((resolve, reject) => {
    dd.device.audio.resume({
      localAudioId: localAudioId,
      onSuccess() {
        resolve()
      },
      onFail(e) {
        reject(e)
      }
    })
  })
}

// 停止播放音频
export function dingAudioStop(localAudioId) {
  return new Promise((resolve, reject) => {
    dd.device.audio.stop({
      localAudioId: localAudioId,
      onSuccess(res) {
        resolve(res)
      },
      onFail(e) {
        reject(e)
      }
    })
  })
}

// 监听播放自动停止
export function dingAudioPlayEnd() {
  return new Promise((resolve, reject) => {
    dd.device.audio.onPlayEnd({
      onSuccess(res) {
        resolve(res)
      },
      onFail(e) {
        reject(e)
      }
    })
  })
}

// 语音转文字
export function dingAudioTranslateVoice(mediaId, duration) {
  return new Promise((resolve, reject) => {
    dd.device.audio.translateVoice({
      mediaId: mediaId,
      duration: duration,
      onSuccess(res) {
        resolve(res)
      },
      onFail(e) {
        reject(e)
      }
    })
  })
}

// 获取会话信息
export function dingPickConversation(corpId, isConfirm) {
  return new Promise((resolve, reject) => {
    dd.biz.chat.pickConversation({
      corpId: corpId, // 企业id,必须是用户所属的企业的corpid
      isConfirm: isConfirm, // 是否弹出确认窗口，默认为true
      onSuccess(res) {
        resolve(res)
      },
      onFail(e) {
        reject(e)
      }
    })
  })
}

// 根据corpid选择会话
export function dingCchooseConversationByCorpId(
  corpId,
  isAllowCreateGroup,
  filterNotOwnerGroup
) {
  return new Promise((resolve, reject) => {
    dd.biz.chat.chooseConversationByCorpId({
      corpId: corpId, // 企业id,必须是用户所属的企业的corpid
      isAllowCreateGroup: isAllowCreateGroup,
      filterNotOwnerGroup: filterNotOwnerGroup,
      onSuccess(res) {
        resolve(res)
      },
      onFail(e) {
        reject(e)
      }
    })
  })
}

// 根据chatId跳转到对应会话
export function dingTtoConversation(corpId, chatId) {
  return new Promise((resolve, reject) => {
    dd.biz.chat.toConversation({
      corpId: corpId, // 企业id,必须是用户所属的企业的corpid
      chatId: chatId,
      onSuccess(res) {
        resolve(res)
      },
      onFail(e) {
        reject(e)
      }
    })
  })
}

// 打开与某个用户的单聊会话
export function dingOpenSingleChat(corpId, userId) {
  return new Promise((resolve, reject) => {
    dd.biz.chat.openSingleChat({
      corpId: corpId, // 企业id,必须是用户所属的企业的corpid
      userId: userId, // 用户的工号
      onSuccess(res) {
        resolve(res)
      },
      onFail(e) {
        reject(e)
      }
    })
  })
}

export function dingRequestAuthInfo(code) {
  return new Promise((resolve, reject) => {
    let obj = {
      modelKey: 'dd.oa|bpms',
      bizScene: 'processCode',
      content: [code]
    }
    dd.biz.auth.requestAuthInfo({
      authorizeType: 1,
      ext: JSON.stringify(obj),
      onSuccess(result) {
        resolve((result || {}).code || '')
      },
      onFail(e) {
        reject(e)
      }
    })
  })
}

/**
 *
 * @param {*} params
 * @returns
 */
// 创建钉消息
export const dingCreateMessage = params => {
  return new Promise((resolve, reject) => {
    dd.biz.ding.create({
      users: [],
      type: 2,
      alertType: 2,
      attachment: {},
      text: '',
      bizType: 0,
      ...params,
      onSuccess: function (res) {
        resolve(res)
        // onSuccess将在点击发送之后调用
      },
      onFail: function (err) {
        reject(err)
      }
    })
  })
}
// 分享
export function dingShare(params) {
  return new Promise((resolve, reject) => {
    dd.biz.util.share({
      type: params.type || 1, // 分享类型，0:全部组件 默认；1:只能分享到钉钉；2:不能分享，只有刷新按钮
      url: params.url,
      title: params.title,
      content: params.content,
      image: params.image,
      onSuccess(res) {
        resolve(res)
      },
      onFail(e) {
        reject(e)
      }
    })
  })
}
